import type { RequestResponse } from '@/types/publicType'
import type {
  callPricesInterface,
  matchPoolDetailInterface,
  callEndInfoInterface,
  noRechargeFreeMatchInterface,
  callIncomeInterface,
  billRecordInterface,
  chargeProdListInterface
} from '@/types/apiType/callType'

/**
 * 拨号
 * @param {number} targetUid 目标ID
 * @param {0|1} match 0正常拨号，1匹配拨号
 * @param {1|4|5|6|101} callType  网页端：1首页，4直播间，5私聊，6个人弹窗，101充值复拨 ；APP：1热门页，2发现页，3关注页，4直播间页，5私聊，6个人主页，7个人小窗，8 h5
 * @param {boolean} useFree 是否使用电话卡
 */
export function apiCallDial(params: {
  targetUid: number
  match: 0 | 1
  callType: 1 | 4 | 5 | 6 | 101
  useFree: boolean
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/dial',
    method: 'GET',
    params,
    loading: true,
    isCloseTost: true
  })
}
/**
 * 接听-允许
 * @param {number} targetUid 接收消息的用户
 */
export function apiCallEnable(params: {
  targetUid: number
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/enable',
    method: 'GET',
    params
  })
}
/**
 * 拒绝接听或取消拨号
 * @param {number} calledUid 目标ID
 * @param {0|1|2} refuseType 2 匹配拒绝 1 拒绝接听 0 超时
 */
export function apiCallCancel(params: {
  calledUid: number
  refuseType: 0 | 1 | 2
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/cancel',
    method: 'GET',
    params
  })
}
/**
 * 获取被呼叫人的通话价格
 * @param {number} priceUid // 被呼叫人
 * @param {1|2} type // 1：拨打，2：匹配
 */
export function apiGetCallPrices(data: {
  priceUid: number
  type: 1 | 2
}): Promise<RequestResponse<callPricesInterface>> {
  return getFetchData({
    url: '/h5/c/prices',
    method: 'POST',
    data
  })
}
/**
 * 通话结束-结束扣费
 * @param {number | string} roomId 房间ID
 */
export function apiCallHang(params: {
  roomId: number | string
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/hang',
    method: 'GET',
    params
  })
}

/**
 * 通话结束的信息
 * @param {number | string} callId
 * @param {number | string} roomId 房间ID
 */
export function apiCallEndInfo(params: {
  callId: number | string
  roomId: number | string
}): Promise<RequestResponse<callEndInfoInterface>> {
  return getFetchData({
    url: 'h5/c/endInfo',
    method: 'GET',
    params
  })
}

/**
 * 匹配-加入
 */
export function apiCallMatch(): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/m',
    method: 'GET',
    params: {
      appVersion: 1
    },
    loading: true
  })
}
/**
 * 匹配-取消
 */
export function apiCallCancelMatch(): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/cm',
    method: 'GET'
  })
}

/**
 * 匹配检测
 */
export function apiMatchPoolDetail(): Promise<
  RequestResponse<matchPoolDetailInterface>
> {
  return getFetchData({
    url: '/h5/c/matchPoolDetail',
    method: 'GET'
  })
}

/**
 * 免费卷匹配，返回主播预录视频
 */
export function apiNoRechargeFreeMatch(): Promise<
  RequestResponse<noRechargeFreeMatchInterface>
> {
  return getFetchData({
    url: '/h5/c/noRechargeFreeMatch',
    method: 'POST'
  })
}

/**
 * 免费卷匹配，返回主播预录视频
 * @param {number} callId roomUid
 * @param {number} callDetailId 挂断接口用到,短视频通话状态记录ID
 * @param {number} second 结束倒计时
 */
export function apiFreeMatchEnd(data: {
  callId: number
  callDetailId: number
  second: number
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/c/freeMatchEnd',
    method: 'POST',
    data
  })
}

/**
 * 我的收益
 */
export function apiCallIncome(): Promise<RequestResponse<callIncomeInterface>> {
  return getFetchData({
    url: '/call/h5/callIncome',
    method: 'GET'
  })
}

/**
 * 收益账单记录
 * @param params.pageNo
 * @param params.pageSize
 * @param params.type 1、视频收入 2、收礼 3、其他收入
 * @param params.date 时间戳
 */
export function apiBillRecord(params: {
  pageNo: number
  pageSize: number
  type: number
  date: number
}): Promise<RequestResponse<billRecordInterface>> {
  return getFetchData({
    url: '/billrecord/h5/get',
    method: 'GET',
    params
  })
}

/**
 * 获取兑换列表
 * @param params.channelType 8.金豆兑换钻石
 */
export function apiChargeProdList(params: {
  channelType: number
}): Promise<RequestResponse<chargeProdListInterface>> {
  return getFetchData({
    url: '/h5/chargeProd/list',
    method: 'GET',
    params
  })
}

/**
 * 兑换金币
 * @param data.diamondNum 需要支出的数值(这里是金豆)
 */
export function apiExchangeDiamond(data: {
  diamondNum: number
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/exchange/gold',
    method: 'POST',
    data
  })
}
